export default "__VITE_ASSET__BX1jpQ56__"